import { getInstance } from '../index';
import { getEnvironmentVariable } from '../env';

class App {
  constructor() {
    this.axios = getInstance();
  }

  async getAppConfig() {
    const appConfigUri = getEnvironmentVariable('BOOTSTRAP_CONFIG_URI');
    const response = await this.axios.get(appConfigUri);
    return response.data;
  }
}

const app = new App(getInstance());
export default app;
